import React from "react";
import BaseComponent from "./BaseComponent";
import Dropdown from "./Dropdown";
import ModuleInputsGroup from "./ModuleInputsGroup";
export default class CoMoWizardConfig extends BaseComponent {
    /**
     * Global exception handling
     * @module ErrorHandling
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            promptOptions: this.getPromptOptions(),
            moduleInputs: this.getModuleInputs(),
            inputOptions: this.getInputOptions(),
            expectedIntentOptions: this.getExpectedIntentOptions(),
        };
    }

    componentDidMount() {
        const promptOptions = this.props.appContext.knowledgeBase.getPrompts();
        this.setState({ promptOptions: promptOptions })
    }

    setConfig(key, value) {
        const wizardConfig = this.props.wizardConfig
        wizardConfig[key] = value;
        wizardConfig.lastLocalChange = window.apm.timestamp;
        this.props.appContext.setSerializedChanged();
    }

    getConfig(key) {
        return this.props.wizardConfig[key];
    }
    getPromptOptions() {
        const prompts = this.props.appContext.knowledgeBase.getPrompts();
        return prompts.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }
    getInputOptions() {
        return this.props.appContext.knowledgeBase.getInputTypes()
    }
    getExpectedIntentOptions() {
        return this.props.appContext.knowledgeBase.getIntents();
    }
    getModuleInputs() {
        const localVariables = this.props.appContext.serialized.components.modules.find(m => m.id === "rootModule").localVariables;
        let moduleInputs = [];
        localVariables.forEach(lv => {
            if (lv.props.config.moduleInput) {
                moduleInputs.push(lv);
            }
        })
        return moduleInputs;
    }
    // will need this for updated propmpts
    componentWillReceiveProps(nextProps) {
        this.setState({ 'promptOptions': this.getPromptOptions() });
        this.setState({'moduleInputs': this.getModuleInputs()})
    }

    
    getPropmptDropdownSelection(type) {
        return this.props.appContext.knowledgeBase.getIndexFromValue(this.getConfig(type), this.state.promptOptions);
    }

    getDropdownSelection( type,options) {
        return this.props.appContext.knowledgeBase.getIndexFromValue(this.getConfig(type), options);
    }

    render() {

        return (
            <div className="col-md-12">
                <div className="row" >
                    <div className="col-md-6">
                        <Dropdown
                            label={window.l.settings.initialPrompt}
                            context={this}
                            optionName={window.l.settings.select_prompt}
                            options={this.state.promptOptions}
                            valKey={"initialPrompt"}
                            selection={this.getPropmptDropdownSelection("initialPrompt")}
                            removable={true} />
                    </div>
                    <div className="col-md-6">
                        <Dropdown
                            label={window.l.settings.invalidPrompt}
                            context={this}
                            optionName={window.l.settings.select_prompt}
                            options={this.state.promptOptions}
                            valKey={"invalidPrompt"}
                            selection={this.getPropmptDropdownSelection("invalidPrompt")}
                            removable={true} />
                    </div>
                    <div className="col-md-6">
                        <Dropdown
                            label={window.l.settings.rePrompt}
                            context={this}
                            optionName={window.l.settings.select_prompt}
                            options={this.state.promptOptions}
                            valKey={"rePrompt"}
                            selection={this.getPropmptDropdownSelection("rePrompt")}
                            removable={true} />
                    </div>
                    <div className="col-md-6">
                        <Dropdown
                            label={window.l.settings.confirmPrompt}
                            context={this}
                            optionName={window.l.settings.select_prompt}
                            options={this.state.promptOptions}
                            valKey={"confirmPrompt"}
                            selection={this.getPropmptDropdownSelection("confirmPrompt")}
                            removable={true} />
                    </div>
                    <div className="col-md-6">
                        <Dropdown
                            label={"Expected Intent"}
                            context={this}
                            optionName={"Select Expected Intent"}
                            options={this.state.expectedIntentOptions}
                            valKey={"expectedIntent"}
                            selection={this.getDropdownSelection("expectedIntent",this.state.expectedIntentOptions)}
                            removable={true} />
                    </div>
                    <div className="col-md-6">
                        <Dropdown
                            label={"Input Type"}
                            context={this}
                            optionName={"Select Input Type"}
                            options={this.state.inputOptions}
                            valKey={"inputType"}
                            selection={this.getDropdownSelection("inputType", this.state.inputOptions)}
                            removable={true} />
                    </div>
                </div>
                <hr />
                <div className={"row"}>
                    <div className="col-md-12" style={{marginTop:"10px",fontSize:"14px"}}>
                        <label>Module Inputs</label>
                    </div>
                        <div className={"col-md-12"}>
                        {(() => {
                            const moduleNodeGroup = [];
                            moduleNodeGroup.push(
                                <ModuleInputsGroup 
                                    context={this}
                                    moduleInputs={this.state.moduleInputs}
                                    key={"moduleInputs"}
                                />);
                            return moduleNodeGroup;
                        })()}
                    </div>
                </div>
            </div>
        );
    }
}